import { Component, OnDestroy } from '@angular/core';
import { NgClass } from '@angular/common';
import { ModalID } from 'src/app/shared/models/constants';
// Third Party
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { SharedService } from 'src/app/shared/services/shared.service';
import { AccountingService } from 'src/app/accounting/services/accounting.service';
@Component({
    selector: 'app-import-by-category',
    templateUrl: './import-by-category.component.html',
    styleUrls: ['./import-by-category.component.scss'],
    standalone: true,
    imports: [NgClass]
})
export class ImportByCategoryComponent {
  category_list: {}[] = []; // {category: string, selected: boolean}[] = [];
  selected_categories: string[] = [];
  // Modals
  modalRef: BsModalRef;
  modalConfig = { animated: true };
  category_and_count: {
    count: number;
    category: string;
  };
  bolded_categories: string[] = [
    'ACCESSORIES',
    'AMMO',
    'LASERS',
    'KNIVES AND RELATED ITEMS',
    'LIGHTS AND ACCESSORIES',
    'MAGAZINES (REPLACEMENT)',
    'OPTICS',
    'PISTOL',
    'REVOLVER',
    'RIFLE',
    'SCOPE MOUNTS AND RINGS',
    'SHOTGUN',
    'SPOTTING SCOPES',
    'TRIGGERS',
  ];

  constructor(
    private modalService: BsModalService,
    private sharedService: SharedService,
    public accountingService: AccountingService
  ) {}
  ngOnInit(): void {
   
  }
 
  isBoldCategory(category: string): boolean {
    return this.bolded_categories.includes(category);
  }
  toggleCategory(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    const category = checkbox.id;
    if (checkbox.checked) {
      this.selected_categories.push(category);
    } else {
      this.selected_categories = this.selected_categories.filter(
        (c) => c !== category
      );
    }
  }
  importCategories() {
    this.accountingService.categories_selected_for_import$.next(
      this.selected_categories
    );
    this.closeModalClick();
  }

  closeModalClick(): void {
    this.modalService.hide(ModalID.import_vendor_inventory);
  }
  ngOnDestroy(): void {
    // this.subscriptions.unsubscribe();
  }
}

class category_and_count {
  count: number;
  category: string;
}
